import { getRequestPathPattern } from "shared/api/getRequestPathPattern"

import Honeybadger from "@honeybadger-io/js"

import { NetworkError } from "./NetworkError"
import { RequestErrorArgs } from "./RequestError"

interface FetchErrorArgs extends RequestErrorArgs {
  cause?: unknown
}

export class FetchError extends NetworkError {
  cause?: unknown

  constructor({ cause, ...args }: FetchErrorArgs) {
    super(args)
    this.name = "FetchError"
    this.cause = cause
  }

  async notify() {
    // The user has no connection, nothing for us to act on
    if (typeof navigator !== "undefined" && navigator.onLine === false) {
      return
    }

    const method = (this.init?.method ?? "GET").toUpperCase()
    const pathPattern = getRequestPathPattern(this.path)

    Honeybadger.notify(this, {
      name: this.name,
      message: this.message,
      stack: this.stack,
      fingerprint: `${this.name}:${method}:${pathPattern}`,
      // The request body is left out on purpose: it can hold large customer payloads
      params: { method, path: this.path },
      context: {
        cause: this.cause instanceof Error ? this.cause.message : this.cause
      }
    })
  }
}
